import { LoadingIcon } from '../icons/loading'

export function LoadingScreen() {
  return (
    <section className="flex min-h-screen w-full flex-col items-center justify-center gap-4 px-2 py-12">
      <LoadingIcon className="h-8 w-8 animate-spin" />
      <p className="animate-pulse text-center font-line font-bold text-black">
        กำลังโหลด...
      </p>
    </section>
  )
}
